export type AdAccountGroupModel = {
  cacheKey: number,
  id: number,
  name: string,
  productLineId: number,
}

export type AdAccountGroupRequestOptions = {}

const state = {
  id: null,
  name: '',
  productLineId: null,
}

export const requiredFields = [
  { key: 'name' },
  { key: 'productLineId' },
]

export default state
